import { round } from '@/helpers/calculations';
import build from '../store/modules/motor/build';

const buildPreferences = build.state.preferences;
const efficiencyAmount = 62.8;
const newtonMeter = 0.101972;

function getValueByUnit(value) {
  if (buildPreferences.unit && buildPreferences.unit === 'newton') {
    return value;
  }

  return convertNmToKg(value);
}

function getRpmCalculation(lpm, cc, convert = false) {
  if (!lpm || !cc) {
    return 0;
  }

  if (convert) {
    return round(getValueByUnit((lpm * 1000) / cc));
  }

  return round((lpm * 1000) / cc);
}

function getTorqueCalculation(pressure, cc, convert = false) {
  const efficiency = buildPreferences.efficiency;
  const efficiencyValue = (efficiencyAmount / efficiency);

  if (!pressure || !cc) {
    return 0;
  }

  if (convert) {
    return round((getValueByUnit((cc * pressure) / efficiencyValue) / 100));
  }

  return round(((cc * pressure) / efficiencyValue) / 100);
}

function getPowerCalculation(torque, rpm, convert = false) {
  if (!torque || !rpm) {
    return 0;
  }

  if (convert) {
    return round(getValueByUnit(torque * (rpm / 9550)));
  }

  return round(torque * (rpm / 9550));
}

function convertNmToKg(value) {
  return value * newtonMeter;
}

function hasWarning(calcValue, staticValue) {
  return parseFloat(calcValue) > parseFloat(staticValue);
}

export { getRpmCalculation, getTorqueCalculation, getPowerCalculation, convertNmToKg, getValueByUnit, hasWarning };